import React from "react";
import { withRouter } from "../router/withRouter";
import CryptoJS from "crypto-js";

class CreatePayPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { paymentRequest: {} };
  }

  componentDidMount() {
    const params = this.useQueryParams();
      const id = params["id"];
      const signature = params["signature"];
      fetch(`/v1/transaction?id=${id}&signature=${signature}`)
          .then((res) => res.json())
          .then((data) => {
              const {id, cardknoxIFieldsKey, amount, currencyCode, organizationId, softwareName, softwareVersion} = data;

              localStorage.setItem("transactionId", id);
              localStorage.setItem("cardknoxIFieldsKey", cardknoxIFieldsKey);
              localStorage.setItem("signature", signature);
              localStorage.setItem("organizationId", organizationId);
              localStorage.setItem("amount", amount);
              localStorage.setItem("currency_code", currencyCode);
              localStorage.setItem("softwareName", softwareName);
              localStorage.setItem("softwareVersion", softwareVersion);

              return setTimeout(() => this.props.router.navigate("/paymentpage"));
          });
  }

  useQueryParams = () => {
    const params = new URLSearchParams(window ? window.location.search : {});

    return new Proxy(params, {
      get(target, prop) {
        return target.get(prop);
      },
    });
  };

  render() {
    return null;
  }
}

export default withRouter(CreatePayPage);
